import type { PropsWithChildren } from 'react';
import React from 'react';
import Box from '@mui/material/Box';

import Footer from 'src/components/other/Footer';

const LegalLayout: React.FC<PropsWithChildren> = ({ children }) => (
    <>
        {children}
        <Box mt="auto">
            <Footer />
        </Box>
    </>
);

export default LegalLayout;
